import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const BUZZ_CONTACT_US_FORM = 'contact-us-form';
export const MEMBERSHIP_FIELD = 'membership';
export const CUSTOM_FIELD_DATA_TYPES = [MEMBERSHIP_FIELD, VALIDATION_FIELDS.postcode, VALIDATION_FIELDS.phone];
export const PASSWORD_CHANGE_CONFIRMATION = 'password-change-conformation';
export const NAME_OF_QUERY_TO_TRIGGER_POPUP = 'Forgotten password';
